import React from 'react';

import { CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import CommonPaginatedTable from "../Common/CommonPaginatedTable";
import SubscriberSmallProfile from "../Profile/SubscriberSmallProfile";
import CommonCallBackButton from "../Common/CommonCallBackButton";
import ArchiveIcon from "@mui/icons-material/Archive";
import RoomSubscriberCreateModal from "./RoomSubscriberCreateModal";


class RoomSubscribers extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            subscribers: null,
            archivedSubscribers: null,
        }
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.roomSubscriber.id !== this.props.roomSubscriber.id) {
            await this.retrieveSubscribers()
        }
    }

    async componentDidMount() {
        await this.retrieveSubscribers()
    }

    async retrieveSubscribers(){
        const url = `room_subscriber/`;
        const api = new BaseApi();
        let params = {
            room: this.props.room.id,
            page_size: 10000,
            archived: false,
            ordering: 'xtype'
        };
        let response = await api.get(
            url,
            params
        );
        let subscribers = response.data.results
        params.archived = true
        response = await api.get(
            url,
            params
        );
        let archivedSubscribers = response.data.results
        this.setState({
            subscribers: subscribers,
            archivedSubscribers: archivedSubscribers,
        })
    }

    async archive(id) {
        const url = `room_subscriber/${id}/archive`;
        const api = new BaseApi();
        await api.get(
            url,
            {}
        );
        await this.retrieveSubscribers()
    }

    async promote(id) {
        const url = `room_subscriber/${id}/`;
        const api = new BaseApi();
        await api.patch(
            url,
            {xtype: 'ADMIN'}
        );
        await this.retrieveSubscribers()
    }

    render() {
        if (!this.state.subscribers || !this.state.archivedSubscribers) {
            return (
                <CircularProgress/>
            )
        }
        return(
            <Stack
                spacing={1}
                sx={{
                    width: '435px',
                    overflowY: 'scroll',
                }}
            >
                <CommonPaginatedTable
                    title={'Текущие участники'}
                    data={this.state.subscribers}
                    extraComponents={[
                        {
                            component: RoomSubscriberCreateModal,
                            componentProps: {
                                subscribers: this.state.subscribers,
                                room: this.props.room,
                                callBack: this.retrieveSubscribers.bind(this),
                                key: 'RoomSubscriberCreateModal' + this.props.room.id,
                            },
                            hidden: !['OWNER', 'ADMIN'].includes(this.props.roomSubscriber.xtype)
                        },
                    ]}
                    callBack={this.retrieveSubscribers.bind(this)}
                    fields={[
                        {
                            title: 'Участник',
                            component: SubscriberSmallProfile,
                            componentProps: {
                                componentObjKey: 'subscriber'
                            },
                            visible: true,
                        },
                        {
                            title: 'Роль',
                            name: 'xtype_human',
                            visible: true,
                            chip: true,
                            color_rule: (value, comparison) => (value),
                            color_value: 'color',
                        },
                        {
                            title: '',
                            visible: ['OWNER', 'ADMIN'].includes(this.props.roomSubscriber.xtype),
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                icon: ArchiveIcon,
                                color: 'danger',
                                flat: true,
                            },
                            callBack: this.archive.bind(this),
                            width: '30px',
                            rowHidden: {
                                rule: (value, comparison) => (value === 'OWNER'),
                                value: 'xtype',
                            },
                        },
                        {
                            title: '',
                            visible: this.props.roomSubscriber.xtype === 'OWNER',
                            component: CommonCallBackButton,
                            componentProps: {
                                propsObject: 'componentObj',
                                propsObjectKey: 'id',
                                label: 'Повысить',
                                color: 'warning',
                                flat: true,
                            },
                            rowHidden: {
                                rule: (value, comparison) => (['OWNER', 'ADMIN'].includes(value)),
                                value: 'xtype',
                            },
                            callBack: this.promote.bind(this),
                        }
                    ]}
                />
                <CommonPaginatedTable
                    title={'Архивные участники'}
                    data={this.state.archivedSubscribers}
                    extraComponents={[]}
                    callBack={this.retrieveSubscribers.bind(this)}
                    fields={[
                        {
                            title: 'Участник',
                            component: SubscriberSmallProfile,
                            componentProps: {
                                componentObjKey: 'subscriber'
                            },
                            visible: true,
                        },
                        {
                            title: 'Роль',
                            name: 'xtype_human',
                            visible: true,
                            chip: true,
                            color_rule: (value, comparison) => (value),
                            color_value: 'color',
                        },
                    ]}
                />
            </Stack>
        )
    }
}

export default RoomSubscribers
